import Vue from 'vue'
import VueRouter from 'vue-router'
import Summary from '@/views/Summary'
import Volume from '@/views/Volume'
import DevelopmentVolume from '@/views/DevelopmentVolume'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/summary'
  },
  {
    path: '/summary/:year?/:month?',
    name: 'summary',
    component: Summary
  },
  {
    path: '/volume/:year?',
    name: 'volume',
    component: Volume
  },
  {
    path: '/development-volume/:year?',
    name: 'development-volume',
    component: DevelopmentVolume
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes
})

export default router
